import React from 'react'
import { useMatch } from 'react-router-dom'
import FolderPage from '../pages/FolderPage'

const FolderWrapper = () => {
  const match = useMatch('/:org/:project/*')
  const rest = match?.params['*'] || ''

  const directoryPath = rest // ceo preostali path kao string

  return <FolderPage directoryPath={directoryPath} />
}

export default FolderWrapper
